import { sanitizeHtml } from "@/lib/html/htmlSanitizer";
import { cn } from "@/lib/utils/cn";

type RichTextProps = {
  /** Raw HTML string. Sanitized before rendering. */
  html: string;
  className?: string;
};

// Tailwind styling for sanitized, injected HTML. Kept in one place so consumers
// never reach for scss modules or scattered child-variant strings.
const richTextStyles = cn(
  "text-sm text-muted-foreground break-words space-y-2",
  "[&_p]:leading-relaxed",
  "[&_strong]:font-semibold [&_b]:font-semibold",
  "[&_em]:italic [&_i]:italic",
  "[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2",
  "[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1",
  "[&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-1",
  "[&_h1]:text-base [&_h1]:font-semibold [&_h1]:text-foreground",
  "[&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-foreground",
  "[&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-foreground"
);

/**
 * Renders sanitized HTML with consistent Tailwind typography.
 * Use for any backend/feed-provided HTML content.
 */
export function RichText({ html, className }: RichTextProps) {
  const clean = sanitizeHtml(html || "");

  return (
    <div
      className={cn(richTextStyles, className)}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
